// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ds-0";
export var fileCarousel = "_ds-2";
export var removeFileButton = "_ds-1";